export default __webpack_public_path__ + "static/media/logo-FR-desktop.5a0ae855.svg";